import { render, staticRenderFns } from "./subTaskImage.vue?vue&type=template&id=62148379&scoped=true&"
import script from "./subTaskImage.vue?vue&type=script&lang=js&"
export * from "./subTaskImage.vue?vue&type=script&lang=js&"
import style0 from "./subTaskImage.vue?vue&type=style&index=0&id=62148379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62148379",
  null
  
)

export default component.exports